require('./bootstrap')

import Bugsnag from '@bugsnag/js'
import { createApp, h } from 'vue'
import { createPinia } from 'pinia'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import { createInertiaApp } from '@inertiajs/inertia-vue3'
import Backend from '@admin_ui/Components/Common/Layouts/Backend'

const appVersion = require('./../../../package.json').version

Bugsnag.start({
  apiKey: '413be4ffb0d22d190a386200a9d09b21',
  appVersion,
  plugins: [new BugsnagPluginVue()],
})

const bugsnagVue = Bugsnag.getPlugin('vue')

createInertiaApp({
  resolve: (name) => {
    const [domain, path] = name.split('::')

    let page = null

    if (domain === 'Bread') {
      page = require(`./../../../Bread/Resources/ui/Pages/${path}.vue`).default
    } else {
      page = require(`./../../../resources/admin/ui/Pages/${domain}/${path}.vue`).default
    }

    page.layout ??= Backend

    return page
  },
  setup({ el, App, props, plugin, name }) {
    createApp({ render: () => h(App, props) })
      .use(plugin)
      .mixin({
        methods: { route: window.route },
      })
      .use(createPinia())
      .use(bugsnagVue)
      .mount(el)
  },
})
